// Definición de las traducciones para los labels de los atributos
// y las entidades de la base de datos. Se utiliza para traducir los IDs a etiquetas legibles.
const attributes = {
    "general_road_id": "Road ID",
    "startKm": "Start Kilometer",
    "endKm": "End Kilometer",
    "dateValidTo": "Valid To Date",
    "dateValidFrom": "Valid From Date",
    "tenTCategory": "TEN-T Category",
    "routeId": "Route ID",
    "nationalRouteId": "National Route ID",
    "internationalRouteId": "International Route ID",
    "startNodeName": "Start Node Name",
    "general_endnode_name": "End Node Name",
    "general_status": "Status",
    "nameResp": "Organization Name",
    "address_resp": "Organization Address",
    "addressResp": "Organization Address",
    "contactPer": "Contact Person Name",
    "contactNum": "Contact Person Phone",
    "contactEmail": "Contact Person Email",
    "contactPos": "Contact Person Position",
    "contact_email": "Contact Email",
    "contact_num": "Contact Phone",
    "conctact_num": "Contact Phone",
    "contact_per": "Contact Person",
    "contact_pos": "Contact Position",
    "date_valid_for": "Valid For Date",
    "date_valid_from": "Valid From Date",
    "date_valid_to": "Valid To Date",
    "end_km": "End Kilometer",
    "end_km_dir_a": "End Kilometer Direction A",
    "end_km_dir_b": "End Kilometer Direction B",
    "end_node_name": "End Node Name",
    "gis_rw_id": "GIS Railway ID",
    "npm_rw_id": "NPM Railway ID",
    "npm_airports_id": "NPM Airport ID",
    "npm_seaports_id": "NPM Seaport ID",
    "npm_road_id": "NPM Road ID",
    "gis_road_id": "GIS Road ID",
    "gis_iww_id": "GIS Inland Waterway ID",
    "npm_iww_id": "NPM Inland Waterway ID",
    "npm_iww_ports_id": "NPM Inland Waterway Port ID",
    "iww_id": "Inland Waterway ID",
    "river": "River",
    "international_comm": "International Commission",
    "regional_partner": "Regional Partner",
    "remarks": "Remarks",
    "start_km": "Start Kilometer",
    "start_km_dir_a": "Start Kilometer Direction A",
    "start_km_dir_b": "Start Kilometer Direction B",
    "status": "Status",
    "ten_t_category": "TEN-T Category",
    "validated": "Validated",
    "international_route_id": "International Route ID",
    "name_resp": "Organization Name",
    "national_route_id": "National Route ID",
    "route_id": "Route ID",
    "start_node_name": "Start Node Name",
    "node_name": "Node Name",
    "npm_freight_id": "NPM Freight ID",
    "owner_1": "Owner 1",
    "owner_1_per": "Owner 1 Person",
    "owner_other": "Other Owner",
    "owner_other_per": "Other Owner Person",
    "ownership_type": "Ownership Type",
    "air_conn": "Air Connection",
    "air_pollut_ghg_tpy": "Air Pollution GHG (tons per year)",
    "finance_source": "Finance Source",
    "freight_traffic_tons_py": "Freight Traffic (tons per year)",
    "max_axle_load": "Max Axle Load",
    "traction_diesel": "Diesel Traction",
    "traction_electrified": "Electrified Traction",
    "ch_closure_adv_weather_cond": "Closure due to Adverse Weather Conditions",
    "ch_winter_maint_days": "Winter Maintenance Days",
    "ch_embank_fail": "Embankment Failure",
    "co2_ems": "CO2 Emissions",
    "ch_flood_inci": "Flood Incident",
    "clean_fuel_avail": "Clean Fuel Availability",
    "condition": "Condition",
    "containers_traffic_dest": "Containers Traffic Destination",
    "containers_traffic_origin": "Containers Traffic Origin",
    "domestic_traffic": "Domestic Traffic",
    "electrified_access": "Electrified Access",
    "emergency_cost_py": "Emergency Cost (per year)",
    "eu_traffic": "EU Traffic",
    "freight_capacity_tpy": "Freight Capacity (tons per year)",
    "freight_traffic_tons_loaded": "Freight Traffic Tons Loaded",
    "freight_traffic_tons_unloaded": "Freight Traffic Tons Unloaded",
    "fridge_capacity": "Fridge Capacity",
    "hazard_goods_capacity": "Hazardous Goods Capacity",
    "inter_modality": "Intermodality",
    "its": "ITS",
    "its_type": "ITS Type",
    "iww_conn": "Inland Waterway Connection",
    "load_gauge": "Load Gauge",
    "maint_cost_total_py": "Maintenance Cost Total (per year)",
    "nmhc_ems": "NMHC Emissions",
    "noise": "Noise",
    "nox_ems": "NOx Emissions",
    "open_availability": "Open Availability",
    "open_storage": "Open Storage",
    "ppm": "PPM",
    "rail_conn": "Rail Connection",
    "rail_conn_tracks": "Rail Connection Tracks",
    "reefer_capacity": "Reefer Capacity",
    "req_upgrade_inc_cap": "Requires Upgrade (Increased Capacity)",
    "rminal_traffic_aircrafts": "Terminal Traffic Aircrafts",
    "rminal_traffic_vessels": "Terminal Traffic Vessels",
    "road_conn": "Road Connection",
    "road_conn_lanes": "Road Connection Lanes",
    "roro": "RoRo",
    "roros_veh": "RoRo Vehicles",
    "routine_cost_py": "Routine Cost (per year)",
    "sea_conn": "Sea Connection",
    "silos_capacity": "Silos Capacity",
    "so2_ems": "SO2 Emissions",
    "stack_area": "Stack Area",
    "storage_capacity_used": "Storage Capacity Used",
    "tanks_capacity": "Tanks Capacity",
    "terminal_traffic_trains": "Terminal Traffic Trains",
    "terminal_traffic_veh": "Terminal Traffic Vehicles",
    "teu_tons": "TEU Tons",
    "teus_containers_py": "TEUs Containers (per year)",
    "total_area": "Total Area",
    "train_length_740m": "Train Length 740m",
    "tranship_equip": "Transshipment Equipment",
    "tranship_facili_intermod_trans": "Transshipment Facilities for Intermodal Transport",
    "transport_comm_traffic": "Transport Commercial Traffic",
    "trsnshipment_capacity_used": "Transshipment Capacity Used",
    "warehouse_capacity": "Warehouse Capacity",
    "alt_fuel_aval": "Alternative Fuel Availability",
    "activity": "Activity",
    "berths": "Berths",
    "clean_fuels_avai": "Clean Fuels Availability",
    "cold_storage": "Cold Storage",
    "combined_terminals": "Combined Terminals",
    "container_terminal": "Container Terminal",
    "covered_storage": "Covered Storage",
    "danger_goods_storage": "Dangerous Goods Storage",
    "dry_bulk_tons": "Dry Bulk Tons",
    "freight_capacity_tn_py": "Freight Capacity (tons per year)",
    "general_bulk_tons": "General Bulk Tons",
    "handling_equip": "Handling Equipment",
    "iww_cemt_conn": "IWW CEMT Connection",
    "liquid_bulk_tons": "Liquid Bulk Tons",
    "maint_cost_maritime_py": "Maintenance Cost Maritime (per year)",
    "max_draught": "Max Draught",
    "oil_tons": "Oil Tons",
    "passenger_capacity": "Passenger Capacity",
    "passenger_capacity_used": "Passenger Capacity Used",
    "passenger_terminals": "Passenger Terminals",
    "port_terminals": "Port Terminals",
    "port_traffic_py": "Port Traffic (per year)",
    "quay_length": "Quay Length",
    "rail_connection": "Rail Connection",
    "rail_connection_tracks": "Rail Connection Tracks",
    "req_upgrade_inc_cap_freight": "Requires Upgrade (Increased Capacity for Freight)",
    "req_upgrade_inc_cap_pass": "Requires Upgrade (Increased Capacity for Passengers)",
    "road_connection": "Road Connection",
    "road_connection_lanes": "Road Connection Lanes",
    "roro_facilities": "RoRo Facilities",
    "terminal_avai": "Terminal Availability",
    "tons_loaded": "Tons Loaded",
    "tons_unloaded": "Tons Unloaded",
    "total_turnover": "Total Turnover",
    "tranship_facilities_intermo_transp": "Transshipment Facilities for Intermodal Transport",
    "transhipment_capacity_used": "Transshipment Capacity Used",
    "vtmis": "VTMIS",
    "vtmis_deploy": "VTMIS Deployment",
    "waste_facilities": "Waste Facilities",
    "maint_cost_landslide_py": "Maintenance Cost Landslide (per year)",
    "pass_traffic_py": "Passenger Traffic (per year)",
    "teus_py": "TEUs (per year)",
    "danger_goods_tons_turnover": "Dangerous Goods Tons Turnover",
    "maint_cost_riverslide_py": "Maintenance Cost Riverslide (per year)",
    "ris_deploy": "RIS Deployment",
    "bridge_height": "Bridge Height",
    "category": "Category",
    "cemt_class": "CEMT Class",
    "double_lock": "Double Lock",
    "downstream_oper_speed": "Downstream Operating Speed",
    "downstream_veseel_traff": "Downstream Vessel Traffic",
    "draught": "Draught",
    "good_nav_status_maint": "Good Navigation Status Maintenance",
    "max_vessel_length": "Max Vessel Length",
    "max_vessel_width": "Max Vessel Width",
    "min_bridge_height": "Min Bridge Height",
    "min_draught": "Min Draught",
    "non_unitised": "Non-Unitised",
    "ports_trans_stor_faci": "Ports Transport Storage Facilities",
    "req_heavy_maint": "Requires Heavy Maintenance",
    "req_rehab": "Requires Rehabilitation",
    "river_info_sys": "River Information System",
    "single_lock": "Single Lock",
    "unitised": "Unitised",
    "upstream_oper_speed": "Upstream Operating Speed",
    "upstream_vessel_traff": "Upstream Vessel Traffic",
    "width": "Width",
    "ave_travel_time_hvgs": "Average Travel Time for Heavy Goods Vehicles",
    "ave_travel_time_pcs": "Average Travel Time for Passenger Cars",
    "busses_aadt": "Buses Annual Average Daily Traffic",
    "capacity_pcu": "Capacity in Passenger Car Units",
    "capacity_pcu_dir_a": "Capacity in Passenger Car Units (Direction A)",
    "capacity_pcu_dir_b": "Capacity in Passenger Car Units (Direction B)",
    "chainage_traffic_crash": "Chainage Traffic Crash",
    "dangerous_goods_veh_per_aadt": "Dangerous Goods Vehicles Percentage of AADT",
    "design_speed": "Design Speed",
    "emer_maint_cost": "Emergency Maintenance Cost",
    "fata_traffic_crash": "Fatal Traffic Crash",
    "fatalities": "Fatalities",
    "freight_traffic_veh_py": "Freight Traffic Vehicles (per year)",
    "fuel_stations_dir_a": "Fuel Stations (Direction A)",
    "fuel_stations_dir_b": "Fuel Stations (Direction B)",
    "fuel_type": "Fuel Type",
    "fuel_type_dir_a": "Fuel Type (Direction A)",
    "fuel_type_dir_b": "Fuel Type (Direction B)",
    "hgvs_per_aadt": "Heavy Goods Vehicles Percentage of AADT",
    "hp_maint_cost": "High Priority Maintenance Cost",
    "international_traffic_per_aadt": "International Traffic Percentage of AADT",
    "its_comp": "ITS Compliance",
    "lanes_direction_a": "Lanes (Direction A)",
    "lanes_direction_b": "Lanes (Direction B)",
    "length_bridges_dir_a": "Length of Bridges (Direction A)",
    "length_bridges_dir_b": "Length of Bridges (Direction B)",
    "length_open_road_dir_a": "Length of Open Road (Direction A)",
    "length_open_road_dir_b": "Length of Open Road (Direction B)",
    "length_through_locality_dir_a": "Length Through Locality (Direction A)",
    "length_through_locality_dir_b": "Length Through Locality (Direction B)",
    "length_total_dir_a": "Total Length (Direction A)",
    "length_total_dir_b": "Total Length (Direction B)",
    "length_tunnels_dir_a": "Length of Tunnels (Direction A)",
    "length_tunnels_dir_b": "Length of Tunnels (Direction B)",
    "maint_cost_bridges": "Maintenance Cost for Bridges",
    "maint_cost_open_roads": "Maintenance Cost for Open Roads",
    "maint_cost_total": "Total Maintenance Cost",
    "maint_cost_tunnels": "Maintenance Cost for Tunnels",
    "max_longitudinal_gradient_dir_a": "Max Longitudinal Gradient (Direction A)",
    "max_longitudinal_gradient_dir_b": "Max Longitudinal Gradient (Direction B)",
    "max_permit_weight_axle_load": "Max Permitted Weight per Axle Load",
    "max_permit_weight_per_vehicle": "Max Permitted Weight per Vehicle",
    "operating_speed": "Operating Speed",
    "parking_areas_dir_a": "Parking Areas (Direction A)",
    "parking_areas_dir_b": "Parking Areas (Direction B)",
    "passenger_cars_aadt": "Passenger Cars Annual Average Daily Traffic",
    "passengers": "Passengers",
    "pavement_condition": "Pavement Condition",
    "per_toll_evation": "Percentage Toll Elevation",
    "ranked_high_risk": "Ranked High Risk",
    "req_hp_maint_bridges": "Requires High Priority Maintenance for Bridges",
    "req_hp_maint_open_roads": "Requires High Priority Maintenance for Open Roads",
    "req_hp_maint_tunnels": "Requires High Priority Maintenance for Tunnels",
    "req_rehab_bridges": "Requires Rehabilitation for Bridges",
    "req_rehab_open_roads": "Requires Rehabilitation for Open Roads",
    "req_rehab_tunnels": "Requires Rehabilitation for Tunnels",
    "req_upgrade_bridges": "Requires Upgrade for Bridges",
    "req_upgrade_open_roads": "Requires Upgrade for Open Roads",
    "req_upgrade_tunnels": "Requires Upgrade for Tunnels",
    "road_safety_audit": "Road Safety Audit",
    "road_safety_insp": "Road Safety Inspection",
    "road_safety_insp_corr_dates": "Road Safety Inspection Correction Dates",
    "road_tunnel_comp": "Road Tunnel Compliance",
    "routine_maint_cost": "Routine Maintenance Cost",
    "safety_comp": "Safety Compliance",
    "ser_inj": "Serious Injuries",
    "speed_limit": "Speed Limit",
    "supervised_control_center": "Supervised Control Center",
    "tent_req_comp": "TEN-T Requirement Compliance",
    "toll_interop": "Toll Interoperability",
    "toll_lanes_electronic": "Toll Lanes (Electronic)",
    "toll_lanes_manned": "Toll Lanes (Manned)",
    "toll_rate_curr": "Toll Rate (Currency)",
    "toll_rate_hg_veh_pday": "Toll Rate for Heavy Goods Vehicles (per day)",
    "toll_rate_hg_veh_pkm": "Toll Rate for Heavy Goods Vehicles (per km)",
    "toll_rate_pass_cars_pday": "Toll Rate for Passenger Cars (per day)",
    "toll_rate_pass_cars_pkm": "Toll Rate for Passenger Cars (per km)",
    "tolled": "Tolled",
    "tolls_charging_method": "Tolls Charging Method",
    "tolls_type": "Tolls Type",
    "total_inj": "Total Injuries",
    "total_traffic_crash": "Total Traffic Crashes",
    "total_traffic_flow_aadt": "Total Traffic Flow Annual Average Daily Traffic",
    "total_traffic_ser_inj": "Total Traffic Serious Injuries",
    "trucks_aadt": "Trucks Annual Average Daily Traffic",
    "tunnels_dir_a": "Tunnels (Direction A)",
    "tunnels_dir_b": "Tunnels (Direction B)",
    "winter_maint_cost": "Winter Maintenance Cost",
    "active_level_cross_auto_user_prot": "Active Level Crossing with Automatic User Protection",
    "active_level_cross_auto_user_warn": "Active Level Crossing with Automatic User Warning",
    "active_level_cross_man":          "Active Level Crossing (Manual)",
    "active_level_cross_rails_prot":   "Active Level Crossing with Rails Protection",
    "ave_delayed_freight":   "Average Freight Delay",
    "ave_delayed_pass":      "Average Passenger Delay",
    "ave_travel_time_freight": "Average Freight Travel Time",
    "ave_travel_time_pass":    "Average Passenger Travel Time",
    "capacity":      "Capacity",
    "capacity_used": "Capacity Used",
    "cond_track":   "Track Condition",
    "cont_comm_sys":"Control and Communication System",
    "dangerous_goods_freight_trains": "Dangerous Goods Freight Trains",
    "electrification": "Electrification",
    "ertms":           "ERTMS",
    "ertms_deploy_etcs": "ERTMS ETCS Deployment",
    "ertms_deploy_gsmr":"ERTMS GSM-R Deployment",
    "ertms_level":      "ERTMS Level",
    "freight_comm_speed":        "Freight Commercial Speed",
    "freight_line_axle_load":    "Freight Line Axle Load",
    "freight_line_speed":        "Freight Line Speed",
    "freight_line_train_length": "Freight Line Train Length",
    "freight_traffic_tkm_py":    "Freight Traffic (tonne-kilometers per year)",
    "freight_trains":            "Freight Trains",
    "id_2022": "ID 2022",
    "id_2023": "ID 2023",
    "length_bridges_over_12m": "Length of Bridges over 12 m",
    "length_open_track":        "Length of Open Track",
    "length_total":             "Total Length",
    "length_tunnels":           "Length of Tunnels",
    "level_cross_total": "Total Level Crossings",
    "maint_cost_elect":          "Electrical Maintenance Cost",
    "maint_cost_infra":          "Infrastructure Maintenance Cost",
    "maint_cost_sign_telecom":   "Signalling and Telecom Maintenance Cost",
    "maint_cost_total_kmpy":     "Maintenance Cost Total (per km per year)",
    "max_design_speed":          "Maximum Design Speed",
    "max_long_grad_dir_a":       "Maximum Longitudinal Gradient (Direction A)",
    "max_long_grad_dir_b":       "Maximum Longitudinal Gradient (Direction B)",
    "max_oper_speed":            "Maximum Operating Speed",
    "max_train_length":          "Maximum Train Length",
    "min_radius":     "Minimum Radius",
    "national_traffic":"National Traffic",
    "num_accidents":          "Number of Accidents",
    "num_incidents":          "Number of Incidents",
    "num_serious_accidents":  "Number of Serious Accidents",
    "num_signi_accidents":    "Number of Significant Accidents",
    "num_tracks":             "Number of Tracks",
    "pass_comm_speed":        "Passenger Commercial Speed",
    "pass_traffic_pass_km_py":"Passenger Traffic (passenger-kilometers per year)",
    "pass_trains":            "Passenger Trains",
    "passive_level_cross":    "Passive Level Crossing",
    "rail_voltage":  "Rail Voltage",
    "traffic_manag": "Traffic Management",
    "rw_tunnel_comp": "Railway Tunnel Compliance",
    "ser_accident_fatal": "Serious Accident Fatalities",
    "ser_accident_ind_damage_rel": "Serious Accident Indirect Damage Release",
    "ser_accident_levelcross": "Serious Accident Level Crossing",
    "ser_accident_mat_damage": "Serious Accident Material Damage",
    "ser_accident_ser_inj": "Serious Accident Serious Injuries",
    "ser_accident_station": "Serious Accident Station",
    "ser_accident_traffic_disrupt": "Serious Accident Traffic Disruption",
    "ser_accidents_openrail": "Serious Accidents Open Railway",
    "sign_standard": "Signalling Standard",
    "signi_inj_accident_fatal_num": "Significant Injury Accident Fatalities",
    "signi_inj_accident_ind_damage_rel": "Significant Injury Accident Indirect Damage Release",
    "signi_inj_accident_levelcross": "Significant Injury Accident Level Crossing",
    "signi_inj_accident_mat_damage": "Significant Injury Accident Material Damage",
    "signi_inj_accident_ser_inj": "Significant Injury Accident Serious Injuries",
    "signi_inj_accident_station": "Significant Injury Accident Station",
    "signi_inj_accident_traffic_disrupt": "Significant Injury Accident Traffic Disruption",
    "signi_inj_accidents_openrail": "Significant Injuries Accidents Open Railway",
    "signi_inj_accident_num": "Significant Injury Accident Number",
    "teus_conta_py": "TEUs Containers (per year)",
    "track_gauge": "Track Gauge",
    "track_gauge_1435mm": "1435 mm",
    "tunnels":       "Tunnels",
    "req_upgrade_add_line": "Requires Upgrade (Add Line)",
    "apron_area": "Apron Area",
    "apron_capacity": "Apron Capacity",
    "declared_capacity": "Declared Capacity",
    "iata_landing_slot_class": "IATA Landing Slot Class",
    "icao_airport_class": "ICAO Airport Class",
    "ils_cat": "ILS Category",
    "its_aero_info_services": "ITS Aeronautical Information Services",
    "its_comm_sys": "ITS Communication System",
    "its_meteoro_info": "ITS Meteorological Information",
    "its_nav_sys": "ITS Navigation System",
    "its_other_sys": "ITS Other Systems",
    "its_survei_sys": "ITS Surveillance System",
    "its_sys_air_traffic_flow_manage": "ITS System for Air Traffic Flow Management",
    "its_sys_air_traffic_services": "ITS System for Air Traffic Services",
    "its_sys_airspace_manage": "ITS System for Airspace Management",
    "length_runways": "Length of Runways",
    "num_pass_terminals": "Number of Passenger Terminals",
    "num_runways": "Number of Runways",
    "pass_capacity": "Passenger Capacity",
    "pass_terminal_area": "Passenger Terminal Area",
    "runway_capacity_fph": "Runway Capacity (Flights per Hour)",
    "type": "Type",
    "aircraft_mov_cargo_carrirer": "Aircraft Movements Cargo Carrier",
    "aircraft_mov_charter_carrirer": "Aircraft Movements Charter Carrier",
    "aircraft_mov_lowc_carrirer": "Aircraft Movements Low Cost Carrier",
    "aircraft_mov_net_carrirer": "Aircraft Movements Network Carrier",
    "arrivals": "Arrivals",
    "maint_cost_freight_term_py": "Maintenance Cost Freight Terminal (per year)",
    "maint_cost_pass_term_py": "Maintenance Cost Passenger Terminal (per year)",
    "maint_cost_runways_py": "Maintenance Cost Runways (per year)",
    "pass_transit": "Passenger Transit",
    "req_upgrade_inc_runways_len": "Requires Upgrade (Increased Runway Length)",
    "throughput_py": "Throughput (per year)",
    "actual_capex": "Actual Capex",
    "actual_const_period": "Actual Construction Period",
    "actual_freight_tn": "Actual Freight (tons)",
    "actual_maint_cost": "Actual Maintenance Cost",
    "actual_opex": "Actual Opex",
    "actual_pass_traffic": "Actual Passenger Traffic",
    "actual_revenue": "Actual Revenue",
    "actual_train_traffic": "Actual Train Traffic",
    "aft_axle_load_22_5t": "Axle Load 22.5 tons",
    "aft_ertms_deploy_etcs": "ERTMS ETCS Deployment",
    "aft_ertms_deploy_gsmr": "ERTMS GSM-R Deployment",
    "aft_line_speed100km": "Line Speed 100 km/h",
    "aft_track_gauge": "Track Gauge",
    "aft_train_length_740m": "Train Length 740m",
    "axle_load_22_5t": "Axle Load 22.5 tons",
    "bef_axle_load_22_5t": "Axle Load 22.5 tons",
    "bef_ertms_deploy_etcs": "ERTMS ETCS Deployment",
    "actual_capex":               "Actual CAPEX",
    "actual_const_period":        "Actual Construction Period",
    "actual_freight_tn":          "Actual Freight (tons)",
    "actual_maint_cost":          "Actual Maintenance Cost",
    "actual_opex":                "Actual OPEX",
    "actual_pass_traffic":        "Actual Passenger Traffic",
    "actual_revenue":             "Actual Revenue",
    "actual_train_traffic":       "Actual Train Traffic",
    "aft_axle_load_22_5t":        "After Axle Load (22.5 t)",
    "aft_ertms_deploy_etcs":      "After ERTMS ETCS Deployment",
    "aft_ertms_deploy_gsmr":      "After ERTMS GSM-R Deployment",
    "aft_line_speed100km":        "After Line Speed (100 km/h)",
    "aft_track_gauge":            "After Track Gauge",
    "aft_train_length_740m":      "After Train Length (740 m)",
    "axle_load_22_5t":            "Axle Load (22.5 t)",
    "bef_axle_load_22_5t":        "Before Axle Load (22.5 t)",
    "bef_ertms_deploy_etcs":      "Before ERTMS ETCS Deployment",
    "bef_ertms_deploy_gsmr":      "Before ERTMS GSM-R Deployment",
    "bef_line_speed100km":        "Before Line Speed (100 km/h)",
    "bef_track_gauge":            "Before Track Gauge",
    "bef_train_length_740m":      "Before Train Length (740 m)",
    "concept_design":             "Concept Design",
    "concept_design_prep_by":     "Concept Design Prepared By",
    "concept_design_superv_by":   "Concept Design Supervised By",
    "concept_design_title":       "Concept Design Title",
    "concession":                 "Concession",
    "concession_allo":            "Concession Allocation",
    "concession_spec":            "Concession Specification",
    "design_comp_date_actual":    "Design Completion Date (Actual)",
    "design_comp_date_curr_est":  "Design Completion Date (Current Estimate)",
    "design_comp_date_fore":      "Design Completion Date (Forecast)",
    "detail_design":              "Detail Design",
    "detail_design_prep_by":      "Detail Design Prepared By",
    "detail_design_superv_by":    "Detail Design Supervised By",
    "detail_design_title":        "Detail Design Title",
    "ebitda":                     "EBITDA",
    "ei_eirr":                    "Economic IRR",
    "ei_npv":                     "Economic NPV",
    "ei_proj_const_cost":         "Economic Project Construction Cost",
    "ei_proj_plan_des_cost":      "Economic Project Planned Design Cost",
    "ei_sdr":                     "Economic SDR",
    "ei_total_proj_cost":         "Economic Total Project Cost",
    "electrification_aft_proj_imp": "Electrification After Project Implementation",
    "electrification_bef_proj":    "Electrification Before Project",
    "end_km_after":               "End Kilometer (After)",
    "end_km_dir_a_after":         "End Kilometer Direction A (After)",
    "end_km_dir_b_after":         "End Kilometer Direction B (After)",
    "end_node_name_after":        "End Node Name (After)",
    "eni_cli_change_res":         "Environmental Impact: Climate Change Resilience",
    "eni_co2_ems":                "Environmental Impact CO₂ Emissions",
    "eni_nmhc_ems":               "Environmental Impact NMHC Emissions",
    "eni_noise_level":            "Environmental Impact Noise Level",
    "eni_nox_ems":                "Environmental Impact NOₓ Emissions",
    "eni_ppm":                    "Environmental Impact Particulate Matter (PPM)",
    "eni_prote_natua_aff":        "Environmental Impact Protected Natural Areas",
    "eni_so2_ems":                "Environmental Impact SO₂ Emissions",
    "environ_impact_assess":          "Environmental Impact Assessment",
    "environ_impact_assess_prep_by":  "Environmental Impact Assessment Prepared By",
    "environ_impact_assess_superv_by":"Environmental Impact Assessment Supervised By",
    "environ_impact_assess_title":    "Environmental Impact Assessment Title",
    "esti_imp_deadline":          "Estimated Implementation Deadline",
    "eu_fund":                   "EU Funding",
    "eu_fund_allo":              "EU Funding Allocation",
    "eu_fund_spec":              "EU Funding Specification",
    "event_id":                  "Event ID",
    "feasi_study":               "Feasibility Study",
    "fi_dscr":                   "Financial DSCR",
    "fi_fdr":                    "Financial FDR",
    "fi_firr":                   "Financial IRR",
    "fi_firts_year_prof":        "Financial First Year Profit",
    "fi_fnpv":                   "Financial NPV",
    "fi_wacc":                   "Financial WACC",
    "forecast_capex":            "Forecast CAPEX",
    "forecast_const_period":     "Forecast Construction Period",
    "forecast_freight_tn":       "Forecast Freight (tons)",
    "forecast_maint_cost":       "Forecast Maintenance Cost",
    "forecast_opex":             "Forecast OPEX",
    "forecast_pass_traffic":     "Forecast Passenger Traffic",
    "forecast_revenue":          "Forecast Revenue",
    "forecast_train_traffic":    "Forecast Train Traffic",
    "implemented":               "Implemented",
    "interest_during_const":     "Interest During Construction",
    "internat_route_id":         "International Route ID",
    "internat_route_id_after":   "International Route ID (After)",
    "length":                    "Length",
    "line_speed_100km_freight":  "Line Speed (100 km/h Freight)",
    "live_rw_proj_id":           "Live Railway Project ID",
    "mature_proj_fs":            "Mature Project Feasibility Study",
    "national_route_id_after":   "National Route ID (After)",
    "ongoing_proj_fs":           "Ongoing Project Feasibility Study",
    "other_fund":                "Other Funding",
    "other_fund_allo":           "Other Funding Allocation",
    "other_fund_spec":           "Other Funding Specification",
    "other_ifi":                 "Other IFI",
    "other_ifi_allo":            "Other IFI Allocation",
    "other_ifi_spec":            "Other IFI Specification",
    "pre_feasi_study":           "Pre-Feasibility Study",
    "prelim_design":             "Preliminary Design",
    "prelim_design_prep_by":     "Preliminary Design Prepared By",
    "prelim_design_superv_by":   "Preliminary Design Supervised By",
    "prelim_design_title":       "Preliminary Design Title",
    "proj_comp_date_curr_est":   "Project Completion Date (Current Estimate)",
    "proj_comp_date_fore":       "Project Completion Date (Forecast)",
    "proj_feasi_study_prep_by":  "Project Feasibility Study Prepared By",
    "proj_feasi_study_superv_by":"Project Feasibility Study Supervised By",
    "proj_feasi_study_title":    "Project Feasibility Study Title",
    "proj_fund_ebrd":            "Project Funding EBRD",
    "proj_fund_ebrd_allo":       "Project Funding EBRD Allocation",
    "proj_fund_eib":             "Project Funding EIB",
    "proj_fund_eib_allo":        "Project Funding EIB Allocation",
    "proj_fund_nat_budg":        "Project Funding National Budget",
    "proj_fund_nat_budg_allo":   "Project Funding National Budget Allocation",
    "proj_fund_wb":              "Project Funding World Bank",
    "proj_fund_wb_allo":         "Project Funding World Bank Allocation",
    "proj_status_desc":          "Project Status Description",
    "proj_under_prep":           "Project Under Preparation",
    "project_name":              "Project Name",
    "route_id_after":            "Route ID (After)",
    "si_ann_traff_acci_rate_red":"Annual Traffic Accident Rate Reduction",
    "si_ann_traff_dem_gro":      "Annual Traffic Demand Growth",
    "si_modal_trans":            "Modal Transfer",
    "start_km_after":            "Start Kilometer (After)",
    "start_km_dir_a_after":      "Start Kilometer Direction A (After)",
    "start_km_dir_b_after":      "Start Kilometer Direction B (After)",
    "start_node_name_after":     "Start Node Name (After)",
    "tender_start_date_actual":      "Tender Start Date (Actual)",
    "tender_start_date_curr_est":    "Tender Start Date (Current Estimate)",
    "tender_start_date_init_fore":   "Tender Start Date (Initial Forecast)",
    "total_cost_capex":          "Total CAPEX Cost",
    "track_gouge":               "Track Gauge",
    "type_foreseen_interven":    "Type of Foreseen Intervention",
    "actual_terminal_traffic":   "Actual Terminal Traffic",
    "aft_electrification":       "After Electrification",
    "aft_inter_modality":        "After Intermodality",
    "aft_open_avail":            "After Open Availability",
    "bef_electrification":       "Before Electrification",
    "bef_inter_modality":        "Before Intermodality",
    "bef_open_avail":            "Before Open Availability",
    "clean_fuel_availability":   "Clean Fuel Availability",
    "electrifide_access":        "Electrified Access",
    "forecast_terminal_traffic": "Forecast Terminal Traffic",
    "live_freight_proj_id":      "Live Freight Project ID",
    "actual_throughput_traffic":     "Actual Throughput Traffic",
    "aft_clean_fuels":               "After Clean Fuels",
    "aft_rail_conn":                 "After Rail Connection",
    "aft_terminal_avail":            "After Terminal Availability",
    "bef_clean_fuels":               "Before Clean Fuels",
    "bef_rail_conn":                 "Before Rail Connection",
    "bef_terminal_avail":            "Before Terminal Availability",
    "capacity_aft_proj":             "Capacity After Project",
    "capacity_aft_proj_unit_type":   "Capacity After Project Unit Type",
    "capacity_bef_proj":             "Capacity Before Project",
    "capacity_bef_proj_unit_type":   "Capacity Before Project Unit Type",
    "clean_fuels_avail":             "Clean Fuels Availability",
    "forecast_throughput_traffic":   "Forecast Throughput Traffic",
    "live_airports_proj_id":         "Live Airports Project ID",
    "proj_increase_capacity":        "Project Increase Capacity",
    "terminal_avail":                "Terminal Availability",
    "actual_busses":                         "Actual Buses",
    "actual_pass_cars":                      "Actual Passenger Cars",
    "actual_trucks":                         "Actual Trucks",
    "aft_alt_fuels_avai":                    "After Alternative Fuels Availability",
    "aft_its_comp":                          "After ITS Compliance",
    "aft_proj_imp_tent_comp":                "After Project Implementation TEN-T Compliance",
    "aft_toll_interop":                      "After Toll Interoperability",
    "aft_tunnel_comp":                       "After Tunnel Compliance",
    "alternative_fuels":                     "Alternative Fuels",
    "bef_alt_fuels_avai":                    "Before Alternative Fuels Availability",
    "bef_its_comp":                          "Before ITS Compliance",
    "bef_proj_imp_tent_comp":                "Before Project Implementation TEN-T Compliance",
    "bef_toll_interop":                      "Before Toll Interoperability",
    "bef_tunnel_comp":                       "Before Tunnel Compliance",
    "forecast_busses":                       "Forecast Buses",
    "forecast_pass_cars":                    "Forecast Passenger Cars",
    "forecast_trucks":                       "Forecast Trucks",
    "immed_part_tent_net":                   "Immediate Part of TEN-T Network",
    "lanes_dir_a":                           "Lanes (Direction A)",
    "lanes_dir_b":                           "Lanes (Direction B)",
    "live_road_proj_id":                     "Live Road Project ID",
    "motorway_express":                      "Motorway/Expressway",
    "new_tent_sec":                          "New TEN-T Section",
    "new_tent_sec_alt_fuels":                "New TEN-T Section Alternative Fuels",
    "new_tent_sec_its_comp":                 "New TEN-T Section ITS Compliance",
    "new_tent_sec_lanes":                    "New TEN-T Section Lanes",
    "new_tent_sec_length":                   "New TEN-T Section Length",
    "new_tent_sec_pav_cond":                 "New TEN-T Section Pavement Condition",
    "other_high_quali_roads":                "Other High-Quality Roads",
    "project_desc":                          "Project Description",
    "rehab_reconstru":                       "Rehabilitation/Reconstruction",
    "safety_comp_aft_proj_imp":              "Safety Compliance After Project Implementation",
    "safety_comp_bef_proj_imp":              "Safety Compliance Before Project Implementation",
    "target_tent_net":                       "Target TEN-T Network",
    "target_tent_sec":                       "Target TEN-T Section",
    "tolling_interope":                      "Tolling Interoperability",
    "tunnel_comp":                           "Tunnel Compliance",
    "aft_bridge_height":     "After Bridge Height",
    "aft_cemt_class_iv":      "After CEMT Class IV",
    "aft_drought":            "After Draught",
    "aft_ris_deploy":         "After RIS Deployment",
    "bef_bridge_height":      "Before Bridge Height",
    "bef_cemt_class_iv":      "Before CEMT Class IV",
    "bef_drought":            "Before Draught",
    "bef_ris_deploy":         "Before RIS Deployment",
    "cemt_calss_iv_comp":      "CEMT Class IV Compliance",
    "clean_fuel":             "Clean Fuel",
    "live_iww_proj_id":       "Live Inland Waterway Project ID",
    "ris_deployment":         "RIS Deployment",
    "actual_port_traffic":         "Actual Port Traffic",
    "aft_cmt_conn":                "After CEMT Connection",
    "aft_road_conn":               "After Road Connection",
    "aft_waste_facilities":        "After Waste Facilities",
    "bef_cmt_conn":                "Before CEMT Connection",
    "bef_road_conn":               "Before Road Connection",
    "bef_waste_facilities":        "Before Waste Facilities",
    "forecast_port_traffic":       "Forecast Port Traffic",
    "live_seaports_proj_id":       "Live Seaports Project ID",
    "cemt_conn":                "CEMT Connection",
    "live_iww_ports_proj_id":       "Live Inland Waterway Ports Project ID",
};

export const getLabelById = (id) => {
    if (attributes[id] === undefined) {
        console.log(`Label not found: ${id}`); // Advertencia si no se encuentra el ID
    }
    return attributes[id] || id; // Devuelve el label o el ID si no se encuentra
};


// Definición de las entidades y atributos
const related_tables_entities = {
    "railways_npm": "Railways NPM",
    "freight_npm": "Freight Terminal NPM",
    "airports_npm": "Airports NPM",
    "roads_npm": "Roads NPM",
    "iww_npm": "Inland waterways NPM",
    "seaports_npm": "Seaports NPM",
    "iww_ports_npm": "Inland waterways ports NPM",
    "railways_live_pm": "Railways Live PM",
    "freight_live_pm": "Freight Terminal Live PM",
    "airports_live_pm": "Airports Live PM",
    "roads_live_pm": "Roads Live PM",
    "roads_live_nm": "Roads Live NrestM",
    "iww_live_pm": "Inland waterways Live PM",
    "seaports_live_pm": "Seaports Live PM",
    "iww_ports_live_pm": "Inland waterways ports Live PM",

};

const related_tables_attributes = {
    "": "",
    "_env": "Environmental Impact",
    "_id_change": "ID Change",
    "_infra": "Infrastructure",
    "_maint": "Maintenance",
    "_ops": "Operations",
    "_safety": "Safety",
    "_tentcomp": "TENT-Compilance",
    "_desc": "Description",
    "_eligi_tent": "Elegibility TENT",
    "_pi": "Performance Indicators",
    "_indicators": "Indicators",
    "_status": "Status",
};

const nameRelatedTables = {};
Object.entries(related_tables_entities).forEach(([entityKey, entityLabel]) => {
    Object.entries(related_tables_attributes).forEach(([suffix, attrLabel]) => {
        const key = entityKey + suffix;
        // Si 'attrLabel' no está vacío, agregamos un espacio y luego el sufijo; de lo contrario, solo la etiqueta de la entidad.
        const value = attrLabel ? `${entityLabel} ${attrLabel}` : entityLabel;
        nameRelatedTables[key] = value;
    });
});

export const getRelatedTablesById = (table) => {
    return nameRelatedTables[table] || table; // Devuelve el label o el ID si no se encuentra
};